import axios from "axios";

export default axios.create({
  baseURL: "https://api.nahl.tts.h22s.net/scoreapp.php",
});
